import * as React from 'react'
import * as Styles from './WKloadMore.style'

export class WKloadMore extends React.Component {
  public render() {
    return (
      <div className={Styles.WKloadMoreWrap}>
        <i className={Styles.WKloadMore}/>
        <span className={Styles.loadTips}>加载更多</span>
      </div>
    )
  }
}

export default WKloadMore



// WEBPACK FOOTER //
// ./src/components/WKloadMore/WKloadMore.tsx